export default __webpack_public_path__ + "static/farmacia_lusitana_white-a75a563ac37477a399fc87df1e317501.svg";